import type { LoginPayload, LoginResponse } from '@/shared/api'
import { useMutation } from '@tanstack/react-query'
import { login, logout } from '@/shared/api'

export function useLoginMutation() {
  return useMutation({
    mutationFn: async (payload: LoginPayload): Promise<LoginResponse> => login(payload),
  })
}

export function useLogoutMutation() {
  return useMutation({
    mutationFn: async (): Promise<void> => logout(),
  })
}
